import type { ComponentType } from 'react'
import type { SDIconProps } from '@/shared/icons/SDIcon'
import { MutedText, StepDot, StepItem } from '../../../styled-components'

export interface StepLineProps {
  label: string
  Icon: ComponentType<SDIconProps>
  text: string
  done: boolean
  author: string | null
}

const StepLine = ({ label, Icon, text, done, author }: StepLineProps) => (
  <StepItem $done={done} title={label}>
    <StepDot $done={done}>
      <Icon size={13} />
    </StepDot>
    <span>
      {text}
      <MutedText hidden={!author}> · {author}</MutedText>
    </span>
  </StepItem>
)

export default StepLine
